import React, { memo } from 'react'

import GenericPolygonTypeSelector from 'Pods/ThreeDStudio/Shared/GenericPolygonTypeSelector/GenericPolygonTypeSelector'
import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { setPolygonType } from 'Pods/ThreeDStudio/Store/actions/modelSettings'
import { POLYGON_TYPE } from 'Pods/ThreeDStudio/Store/constants'

const handleQuadrilateralClick = () => setPolygonType(POLYGON_TYPE.QUADRILATERAL)
const handleTriangleClick = () => setPolygonType(POLYGON_TYPE.TRIANGLE)

function PolygonTypeSelector() {
  const isSmartLowPoly = useThreeDStudioStore(state => state.modelSettings.isSmartLowPoly)

  return (
    <GenericPolygonTypeSelector
      handleQuadrilateralClick={handleQuadrilateralClick}
      handleTriangleClick={handleTriangleClick}
      sliceName="modelSettings"
      storeSchemaKey="generationModelSchema"
      forceDisabled={isSmartLowPoly}
    />
  )
}

export default memo(PolygonTypeSelector)
